module.exports = __webpack_public_path__ + "static/top-8adb890d43ccfe0e471e627d21850948.png";